import { c as _c } from "react/compiler-runtime";
import { StyledGridMessageLayoutComposerControlsContainer, StyledGridMessageLayoutComposerTopAccessory, StyledGridMessageLayoutContainer, StyledGridMessageLayoutEmptyContent, StyledGridMessageLayoutMaxWidth, StyledGridMessageLayoutMessageListContainer } from './styles';
import { useCenteredEmptyTransition } from './hooks/useCenteredEmptyTransition';
import { useMessageListScrollShadow } from './hooks/useMessageListScrollShadow';
import { type MessageLayoutProps } from './types';
export const MessageLayout = t0 => {
  const $ = _c(38);
  const {
    ref,
    MessageList,
    MessageComposer,
    MessageControls,
    footer,
    composerTopAccessory,
    maxWidth: t1,
    emptyComposerPlacement: t2,
    syncFrameScrollShadow: t3,
    messageListOffsetTop: t4
  } = t0;
  const maxWidth = t1 === undefined ? "100%" : t1;
  const emptyComposerPlacement = t2 === undefined ? "docked" : t2;
  const syncFrameScrollShadow = t3 === undefined ? false : t3;
  const messageListOffsetTop = t4 === undefined ? 0 : t4;
  const isEmpty = MessageList.props.messages.length === 0;
  const emptyContent = MessageList.props.emptyState;
  const shouldCenterWhenEmpty = emptyComposerPlacement === "centered";
  const isCenteredEmpty = shouldCenterWhenEmpty && isEmpty;
  const hasComposerTopAccessory = composerTopAccessory != null;
  const {
    isScrolled,
    messageListRef
  } = useMessageListScrollShadow(isCenteredEmpty, syncFrameScrollShadow);
  let t5;
  if ($[0] !== isCenteredEmpty || $[1] !== shouldCenterWhenEmpty) {
    t5 = {
      isCenteredEmpty,
      shouldCenterWhenEmpty
    };
    $[0] = isCenteredEmpty;
    $[1] = shouldCenterWhenEmpty;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const {
    animateMessageEnter,
    dockRef,
    emptyContentVisible,
    isTransitioning
  } = useCenteredEmptyTransition(t5);
  let t6;
  if ($[3] !== emptyContent || $[4] !== emptyContentVisible || $[5] !== isCenteredEmpty || $[6] !== maxWidth) {
    t6 = isCenteredEmpty && emptyContent != null ? <StyledGridMessageLayoutEmptyContent $isVisible={emptyContentVisible}><StyledGridMessageLayoutMaxWidth maxWidth={maxWidth}>{emptyContent}</StyledGridMessageLayoutMaxWidth></StyledGridMessageLayoutEmptyContent> : null;
    $[3] = emptyContent;
    $[4] = emptyContentVisible;
    $[5] = isCenteredEmpty;
    $[6] = maxWidth;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== MessageList || $[9] !== animateMessageEnter || $[10] !== isCenteredEmpty || $[11] !== maxWidth || $[12] !== messageListOffsetTop || $[13] !== messageListRef) {
    t7 = !isCenteredEmpty ? <StyledGridMessageLayoutMessageListContainer ref={messageListRef} $animateEnter={animateMessageEnter} $offsetTop={messageListOffsetTop}><StyledGridMessageLayoutMaxWidth maxWidth={maxWidth} $paddingTop={messageListOffsetTop}>{MessageList}</StyledGridMessageLayoutMaxWidth></StyledGridMessageLayoutMessageListContainer> : null;
    $[8] = MessageList;
    $[9] = animateMessageEnter;
    $[10] = isCenteredEmpty;
    $[11] = maxWidth;
    $[12] = messageListOffsetTop;
    $[13] = messageListRef;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== composerTopAccessory || $[16] !== hasComposerTopAccessory) {
    t8 = hasComposerTopAccessory ? <StyledGridMessageLayoutComposerTopAccessory>{composerTopAccessory}</StyledGridMessageLayoutComposerTopAccessory> : null;
    $[15] = composerTopAccessory;
    $[16] = hasComposerTopAccessory;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== MessageComposer || $[19] !== MessageControls || $[20] !== footer || $[21] !== maxWidth || $[22] !== t8) {
    t9 = <StyledGridMessageLayoutMaxWidth maxWidth={maxWidth}>{t8}{MessageControls}{MessageComposer}{footer}</StyledGridMessageLayoutMaxWidth>;
    $[18] = MessageComposer;
    $[19] = MessageControls;
    $[20] = footer;
    $[21] = maxWidth;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== dockRef || $[25] !== hasComposerTopAccessory || $[26] !== isCenteredEmpty || $[27] !== isScrolled || $[28] !== maxWidth || $[29] !== t9) {
    t10 = <StyledGridMessageLayoutComposerControlsContainer ref={dockRef} isScrolled={isScrolled} $isCenteredEmpty={isCenteredEmpty} $maxWidth={maxWidth} $hasTopAccessory={hasComposerTopAccessory}>{t9}</StyledGridMessageLayoutComposerControlsContainer>;
    $[24] = dockRef;
    $[25] = hasComposerTopAccessory;
    $[26] = isCenteredEmpty;
    $[27] = isScrolled;
    $[28] = maxWidth;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== isCenteredEmpty || $[32] !== isTransitioning || $[33] !== ref || $[34] !== t10 || $[35] !== t6 || $[36] !== t7) {
    t11 = <StyledGridMessageLayoutContainer ref={ref} $isCenteredEmpty={isCenteredEmpty} $isTransitioning={isTransitioning}>{t6}{t7}{t10}</StyledGridMessageLayoutContainer>;
    $[31] = isCenteredEmpty;
    $[32] = isTransitioning;
    $[33] = ref;
    $[34] = t10;
    $[35] = t6;
    $[36] = t7;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
export default MessageLayout;